import React from "react";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

export function ScoreContainer(props) {
    const { resultObj } = props;
    const { mirs_discipline } = useUrlFriendlyToParameters()

    return (
        <div className='score-result-container justify-content-end'>
            <div className={`text-end ${resultObj?.rCn ? resultObj?.rCn : 'fw-bold'}`}>
                {
                    resultObj?.irm !== undefined
                        ? <SportCode discipline={mirs_discipline} code={resultObj?.irm} entity="@IRM" abbr={true} />
                        : resultObj?.result
                }
            </div>
        </div>
    )
}
